import React, { useState,useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate  } from "react-router-dom";
import { getUrlParameter } from '../infrastructure/apputilityfunctions';
import * as securityActions from '../actions/securityactions';
import securityService from "../services/securityservice"; 

export default function MicrosoftLoginHandler() {
    const navigate=useNavigate();
    const dispatch = useDispatch();  
    let token=getUrlParameter('token');

    useEffect(() => {
        async function init(){
                let users=await securityService.getUsersByMicrosoftLogin(token);
               if(users.length==0){
                    alert('No microsoft login found');
               }else if(users.length==1){
                    createSession(users[0].usR_ID);
               }
        }
        init();
    }, []);
    
    const createSession = (userId) => {
        dispatch(securityActions.createUserSessionFromMicrosoftLogin(token,userId));
    };

}